import { Card, CardHeader, CardContent } from '@mui/material';
import { FormText, FormInputGroup } from 'components/form';
import styles from '../../DeviceConfig.module.scss';

export const DeviceConfigNotes = () => {
    return (
        <div data-testid="DeviceConfigNotes" className={styles.section}>
            <Card className={styles.card}>
                <CardHeader title="Notes" />
                <CardContent>
                    <FormInputGroup>
                        <FormText
                            field="notes"
                            label="Leave a note"
                            isTextArea
                        />
                    </FormInputGroup>
                </CardContent>
            </Card>
        </div>
    );
};
